// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__NDS1t","ellipsis":"styles_ellipsis__KPi0F","text2AndMoreLines":"styles_text2AndMoreLines__1qQ4b","tooltipTrigger":"styles_tooltipTrigger__ObPSK"};